export const predictModels = [
    {
        id: 1,
        Name: "Alpha Model",
        Model_Creater: "Tofunmi",
        Date: "02/04/2023",
        Status: "Active"

    },

    {
        id: 2,
        Name: "Omega Model",
        Model_Creater: "Shakirat",
        Date: "02/04/2023",
        Status: "Inactive"

    }
]


    
